// @ts-check
import React from 'react';
import { GetCopyFromJson } from '~/contentstack/rendering';
import GatsbyImage from './images/GatsbyImage';
import LinkButton from './LinkButton';
import RedBar from './RedBar';

import './SingleImageBlock.scss';

/**
 * @typedef SingleImageBlockOptions
 * @property {import('./LinkButton').ButtonOptions[]} button
 * @property {import('../CSTypes').CSJRTE} copy
 * @property {string} heading
 * @property {import('../CSTypes').BynderImageOptions[]} image
 *
 * @typedef SingleImageBlockProps
 * @property {string} [className]
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<SingleImageBlockOptions>} options
 */
/** @type {React.FC<SingleImageBlockProps>} */
const SingleImageBlock = ({ options }) => {
	if (!options) {
		return null;
	}

	const copy = GetCopyFromJson(options.copy);

	return (
		<div className="single-image-block container">
			<div className="row individual-image-block">
				<div className="image-block-content col-lg-6">
					<RedBar />
					<h3 className="heading" {...options.$?.heading}>
						{options.heading}
					</h3>
					{copy}
					<LinkButton options={options.button?.[0]} />
				</div>
				{!!options.image?.[0] && (
					<div className="image-block-image d-none d-lg-flex col-lg-6">
						<GatsbyImage
							className="image-block-image-inner"
							option={options.image[0]}
							// @ts-ignore - Here we want to force the image to take up physical space natively.
							type="img"
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default SingleImageBlock;
